// extracted by mini-css-extract-plugin
export default {"deleteGroupSubgroupModal":"DeleteGroupSubgroup_deleteGroupSubgroupModal__gq519"};